// 9fbef606107a605d69c0edbcd8029e5d
import Styled, { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';

export const RightArrowButton = Styled.button`
  background: url(${() => getIconPath('carrot-large-right')}) no-repeat center center;
  outline: none;
  height: 18px;
  width: 18px;
  border: none;
`;

export const RightArrowBlackButton = Styled.button`
  border: none;
  outline: none;
  width: 6px;
  height: 7px;
  background: url(${() => getIconPath('toggle-right-arrow')}) no-repeat center center;
  margin-top: 2px;
`;
export const CategoryGroup = Styled.h2`
  width: 100%;
  text-align: center;
  border-bottom: 2px solid ${(props) => props.theme.colors.BORDER.LIGHTGRAY};
  line-height: 0.1em;
  color: ${(props) => props.theme.colors.TEXT.DARK};
  margin-bottom: 24px;
  margin-top: ${(props) => props.top || 10}px;
  font-family: ${(props) => props.theme.fonts.secondary};
  font-size: 32px;
  font-weight: 600;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 25px;
  }
  span {
    background: rgb(255, 255, 255);
    padding: 0px 20px;
  }
`;
export const StyledHrSkeleton = Styled(LoaderSkelton)`
  width: 100%;
  background-color: ${(props) => props.theme.colors.PRIMARY.COLOR1};
`;
export default css`
  &.horizontal-category-view {
    width: 100%;
    .horizontal-carousel {
      background-color: ${(props) => props.theme.colors.PRIMARY.COLOR1};
      margin-bottom: 13px;
      padding: 12px 40px 12px 25px;
      width: 100%;
      box-sizing: border-box;
      @media ${(props) => props.theme.mediaQuery.small} {
        padding: 0 8px 8px 8px;
      }
    }
    .skeleton-wrapper {
      padding: 0 10px;
    }

    [class^='hplp-carousel-skeleton-'] {
      margin: 0 15px;
    }

    @media ${(props) => props.theme.mediaQuery.desktop} {
      padding: 0 12px;
      margin: 0 6px;
    }
    .horizontal-sbc-carousel {
      @media ${(props) => props.theme.mediaQuery.large} {
        margin: 0 15px 32px 15px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 24px;
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        display: flex;
        flex-wrap: wrap;
        padding-right: 0px;
        padding-left: 0;
        margin-bottom: 24px;
      }
    }
    .hr-plp-tile {
      padding: 10px;
      margin-right: 10px;
      @media ${(props) => props.theme.mediaQuery.small} {
        width: 146px;
        margin-right: 0;
        padding: 8px 10px;
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        width: 230px;
        margin-right: 0;
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        padding: 10px 20px;
        margin-right: 10px;
        box-sizing: border-box;
        min-width: 260px;
        max-width: 261px;
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        max-width: 283px;
      }
    }

    .hr-plp-tile.espot-wrapper {
      padding: 0;
      height: 100%;

      .espot-plp-tile {
        align-items: center;
      }

      /* stylelint-disable max-nesting-depth */
      &,
      .espot-promo-dam {
        @media ${(props) => props.theme.mediaQuery.small} {
          max-height: 332.5px;
          min-height: 332.5px;
          min-width: 146px;
        }
        @media ${(props) => props.theme.mediaQuery.mediumOnly} {
          max-height: 472px;
          min-height: 453px;
          min-width: 250px;
        }
        @media ${(props) => props.theme.mediaQuery.large} {
          max-height: 480px;
          min-height: 460px;
          min-width: 260px;
        }
      }
      @media ${(props) => props.theme.mediaQuery.small} {
        margin-right: 0;
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        max-width: 283px;
        margin-right: 0;
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        padding: 0;
        margin-right: 10px;
      }
    }
    .hr-plp-tile .review-ratings {
      @media ${(props) => props.theme.mediaQuery.large} {
        height: 15px;
      }
    }
    .hr-plp-tile .product-image {
      @media ${(props) => props.theme.mediaQuery.large} {
        display: inline-flex;
        width: 100%;
        justify-content: center;
      }
    }

    .extended-sizes {
      min-height: 20px;
    }
    .slick-next {
      height: 30px;
      width: 22px;
    }
    .slick-prev {
      height: 30px;
      width: 22px;
    }
    .slick-disabled {
      display: none !important;
    }

    .slick-slide > div {
      height: 100%;
    }
    .skeleton-container {
      width: 100%;
      .skeleton-row {
        justify-content: center;
      }
    }
    #scroll-element {
      height: 30px;
      width: 90%;
    }
    .horizontalplp-seo-text {
      max-width: 90%;
      margin: 0 auto;
    }
  }
`;

export const StyledFilterContainer = Styled.div`
  padding: 0 18px;
`;
